export const AMOUNT_ACTION = 'AMOUNT_ACTION'
export const CURRENCY_ACTION = 'CURRENCY_ACTION'
export const PAYWAY_ACTION = 'PAYWAY_ACTION'
export const DESTINATION_ACTION = 'DESTINATION_ACTION'
export const SWAP_CURRENCY_ACTION = 'SWAP_CURRENCY_ACTION'
export const EMAIL_ACTION = 'EMAIL_ACTION'
export const VALIDATION_SECOND_SCREEN_ACTION = 'VALIDATION_SECOND_SCREEN_ACTION'
export const ACTIVATE_SECOND_SCREEN_ACTION = 'ACTIVATE_SECOND_SCREEN_ACTION'
export const CARD_NUMBER_ACTION = 'CARD_NUMBER_ACTION'
export const CARD_PHOTO_ACTION = 'CARD_PHOTO_ACTION'
export const CARD_VERIFY_ACTION = 'CARD_VERIFY_ACTION'
export const FILE_INPUT_ACTION = 'FILE_INPUT_ACTION'
export const SCREEN_BACK_ACTION = 'SCREEN_BACK_ACTION'
export const FETCHING_ACTION = 'FETCHING_ACTION'
export const UPLOAD_CARD_PHOTO_ACTION = 'UPLOAD_CARD_PHOTO_ACTION'
export const INIT = '__INIT__'
export const DESTINATION_TAG_ACTION = 'DESTINATION_TAG_ACTION'
export const ORDER_LINK_ACTION = 'ORDER_LINK_ACTION'
export const SHOW_EXAMPLE = 'SHOW_EXAMPLE'
export const LOADER_CUR_FROM = 'LOADER_CUR_FROM'